import React, { Component } from "react";
import logo from "../assets/images/logo3.png";
import "../styles/containers/Header.css";
import { Menu } from "antd";
import Switch from "../components/Switch";
import { withI18n } from "react-i18next";
import { withRouter } from "react-router-dom";

class Header extends Component {
  state = {
    current: "",
    searchValue: null
  };
  handleClick = e => {
    console.log("click ", e);
    this.setState({
      current: e.key
    });
  };

  render() {
    const { t } = this.props;

    console.log(this.props, "props");
    return (
      <div className="header">
        <img
          onClick={() => {
            this.props.history.push("/");
          }}
          className="logo"
          src={logo}
          alt="logo"
        />

        <div className="top-menu">
          <Menu
            onClick={this.handleClick}
            selectedKeys={[this.state.current]}
            mode="horizontal"
            style={MENU_STYLES}
          >
            <Menu.Item className="search-item" key="setting:4">
              <form id="demo-2">
                <input
                  onChange={e => this.props.search(e.target.value)}
                  type="search"
                  placeholder="Search"
                />
              </form>
            </Menu.Item>

            <Menu.Item
              style={ITEM_STYLE}
              key="mai2l"
              onClick={() => {
                this.props.history.push("/");
              }}
            >
              {t("Kuvendi")}
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                this.props.history.push("/news");
              }}
              style={ITEM_STYLE}
              key="lajme"
            >
              {t("Lajme")}
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                this.props.history.push("/struktura");
              }}
              style={ITEM_STYLE}
              key="st2ruktura"
            >
              {t("Struktura")}
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                this.props.history.push("/akte");
              }}
              style={ITEM_STYLE}
              key="dokumenta2cioni"
            >
              Akte
            </Menu.Item>
            {/* <Menu.Item style={ITEM_STYLE} key="struktura2">
              Struktura
            </Menu.Item>
            <Menu.Item style={ITEM_STYLE} key="dokumentacioni2">
              Diplomacia
            </Menu.Item> */}
          </Menu>
        </div>
        <Switch />
      </div>
    );
  }
}
const MENU_STYLES = {
  background: "#444",
  borderBottom: "0px",
  "line-height": "90px",
  color: "white"
};
const ITEM_STYLE = {
  color: "white"
};
export default withRouter(withI18n()(Header));
